module.exports = __webpack_public_path__ + "img/moveUp.ff3043f9.svg";